import React from 'react';

const SEO = ({ title, description, keywords }) => {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {/* Puedes añadir más etiquetas OG si las necesitas, como og:image */}

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* Puedes añadir más etiquetas de Twitter si las necesitas */}
    </>
  );
};

export default SEO;
